import { $api, fetchClient } from "../generated/client";

type DownloadGiftCodeParams = {
	shopId: string;
	giftCodeId: string;
};

export default function useDownloadGiftCode(params: DownloadGiftCodeParams) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}/gift-codes/{giftCodeId}/download",
		{
			params: {
				path: { shopId: params.shopId, giftCodeId: params.giftCodeId },
			},
		},
	);
}

export async function downloadGiftCode({
	giftCodeId,
	shopId,
}: DownloadGiftCodeParams): Promise<{ url: string }> {
	const response = await fetchClient.GET(
		"/shops/{shopId}/gift-codes/{giftCodeId}/download",
		{
			params: { path: { shopId, giftCodeId } },
		},
	);

	return response.data as unknown as { url: string };
}
